package ru.villawonka.app.presentation.screens.searchFilter.viewmodel

import ru.villawonka.app.common.mvvm.UIState
import ru.villawonka.app.domain.model.AccommodationAdditionDomain
import ru.villawonka.app.domain.model.AccommodationTypeDomain
import ru.villawonka.app.domain.model.NetworkFailure
import ru.villawonka.app.presentation.model.CurrencyUIModel
import ru.villawonka.app.presentation.screens.searchFilter.model.ChipUIModel

sealed class SearchFilterUIState : UIState {

    data object Loading : SearchFilterUIState()

    data class Error(val failure: NetworkFailure) : SearchFilterUIState()

    sealed class Data : SearchFilterUIState() {
        abstract val selectedCity: String?
        abstract val selectedDistricts: List<String>
        abstract val cities: List<String>
        abstract val districts: List<ChipUIModel<String>>
        abstract val currency: CurrencyUIModel
        abstract val minCost: Int?
        abstract val maxCost: Int?

        data class Accommodation(
            override val selectedCity: String? = null,
            override val selectedDistricts: List<String> = emptyList(),
            override val cities: List<String> = emptyList(),
            override val districts: List<ChipUIModel<String>> = emptyList(),
            override val currency: CurrencyUIModel = CurrencyUIModel.Usd(),
            override val minCost: Int? = null,
            override val maxCost: Int? = null,
            val accommodationTypes: List<ChipUIModel<AccommodationTypeDomain>> = emptyList(),
            val bedrooms: List<ChipUIModel<String>> = emptyList(),
            val additions: List<ChipUIModel<AccommodationAdditionDomain>> = emptyList(),
        ) : Data()

        data class Transport(
            override val selectedCity: String? = null,
            override val selectedDistricts: List<String> = emptyList(),
            override val cities: List<String> = emptyList(),
            override val districts: List<ChipUIModel<String>> = emptyList(),
            override val currency: CurrencyUIModel = CurrencyUIModel.Usd(),
            override val minCost: Int? = null,
            override val maxCost: Int? = null,
        ) : Data()
    }
}